import { Component, OnInit } from "@angular/core";
import { AccountService } from "../../models/account.service";
import { RememberService } from "../../remember/remember.service";

@Component({
  selector: "ab-error-quota-warning-alert",
  templateUrl: "./error-quota-warning.component.html",
})
export class ErrorQuotaWarningAlertComponent implements OnInit {
  public daysRemaining: number;
  public percentUsed: number;
  public show: boolean;
  public type: string;

  private DANGER_THRESHOLD_PERCENT = 80;

  constructor(
    private accountService: AccountService,
    private rememberService: RememberService,
  ) {}

  public close() {
    // Only remember to keep 1 version of this warning closed, to ensure the
    // warnings start appearing again during the next monthly cycle.
    this.rememberService.forget("alerts.errorQuotaWarning.");
    this.rememberService.set(this.rememberKey(), true);
    this.show = false;
  }

  public ngOnInit() {
    this.show = false;

    this.accountService.properties().subscribe((props: any) => {
      this.percentUsed =
        props.account && props.account.error_quota_used_percent;
      this.daysRemaining =
        props.account && props.account.error_quota_days_remaining;
      this.type =
        this.percentUsed >= this.DANGER_THRESHOLD_PERCENT
          ? "danger"
          : "warning";

      if (this.rememberService.get(this.rememberKey(), false)) {
        return;
      }

      this.show = props.alerts
        ? props.alerts.error_quota_warn_alert === true
        : false;
    });
  }

  // Warnings reappear at every 10% breakpoint, otherwise hiding a 50% warning
  // would prevent the user from seeing all subsequent warnings.
  private rememberKey() {
    const quantisedTenth = Math.floor(this.percentUsed / 10) * 10;
    return `alerts.errorQuotaWarning.${quantisedTenth}.hide`;
  }
}
